(() => {
  const marqueeSelector = '[data-nido-curved-marquee]';
  const textPathSelector = '[data-nido-marquee-text-path]';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const findMarquees = (scope) => {
    const marquees = [];

    if (scope instanceof Element && scope.matches(marqueeSelector)) {
      marquees.push(scope);
    }

    marquees.push(...scope.querySelectorAll(marqueeSelector));
    return marquees;
  };

  const destroyMarquee = (marquee) => {
    marquee.querySelectorAll(textPathSelector).forEach((textPath) => {
      window.gsap?.killTweensOf(textPath);
    });

    marquee.removeAttribute('data-nido-marquee-ready');
  };

  const initMarquee = (marquee) => {
    if (!window.gsap || marquee.hasAttribute('data-nido-marquee-ready')) return;

    const duration = Math.max(Number.parseFloat(marquee.dataset.speed) || 22, 0.1);

    marquee.querySelectorAll(textPathSelector).forEach((textPath) => {
      const startOffset = Number.parseFloat(textPath.dataset.startOffset) || 0;
      textPath.setAttribute('startOffset', `${startOffset}%`);

      if (reducedMotion.matches) return;

      window.gsap.fromTo(
        textPath,
        { attr: { startOffset: `${startOffset}%` } },
        {
          attr: { startOffset: `${startOffset - 100}%` },
          duration,
          ease: 'none',
          repeat: -1,
        }
      );
    });

    marquee.setAttribute('data-nido-marquee-ready', '');
  };

  const initMarquees = (scope = document) => {
    findMarquees(scope).forEach(initMarquee);
  };

  const refreshMotionPreference = () => {
    findMarquees(document).forEach(destroyMarquee);
    initMarquees();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initMarquees(), { once: true });
  } else {
    initMarquees();
  }

  document.addEventListener('shopify:section:load', (event) => initMarquees(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    findMarquees(event.target).forEach(destroyMarquee);
  });

  if (typeof reducedMotion.addEventListener === 'function') {
    reducedMotion.addEventListener('change', refreshMotionPreference);
  } else {
    reducedMotion.addListener(refreshMotionPreference);
  }
})();
